var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    width: 60,
    height: 20,
    fill: "#8B4513"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 130,
    width: 70,
    height: 10,
    fill: "#A0522D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 80,
    width: 10,
    height: 50,
    fill: "#228B22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 15,
    fill: "#32CD32"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "70;65;70",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 12,
    fill: "#32CD32"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "90;85;90",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 12,
    fill: "#32CD32"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "90;85;90",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40 50 Q50 30 70 50 Q60 70 40 50 Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 30,
    width: 8,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 25,
    width: 8,
    height: 25,
    rx: 4,
    ry: 4,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 30,
    width: 8,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 50 Q30 40 45 35 Q50 45 40 50 Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 50,
    x2: 100,
    y2: 60,
    stroke: "#1E90FF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "100;90;100",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "60;70;60",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 2,
    fill: "#1E90FF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "60;140",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 65,
    r: 2,
    fill: "#1E90FF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "65;145",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyPlant);
export default __webpack_public_path__ + "static/media/happy_plant.4cfa7c81899766751c9ab9d44943bc79.svg";
export { ForwardRef as ReactComponent };